import { useTranslation } from 'react-i18next';
import { Table, Pagination } from '@treezor/design-system';
import { useLocation } from 'react-router';

import { AllCardsFilters } from '@/features/cards/components/AllCards/AllCardsFilters';
import { useAllCardsTableData } from '@/features/cards/hooks/AllCards/useAllCardsTableData';

import { ItemsPerPage } from '@/ui-kit/table-filters/ItemsPerPageFilter';
import { EmptyState } from '@/ui-kit/templates/EmptyState/EmptyState';

export function AllCardsTable() {
  const { t } = useTranslation();

  const state = useLocation().state || undefined;

  const {
    pagination,
    error,
    headers,
    rows,
    onPageChange,
    onSort,
    onPerPage,
    perPage,
    fields,
    hasFilters,
    clearFilters,
  } = useAllCardsTableData(state);

  return (
    <div>
      <AllCardsFilters fields={fields} clearFunction={hasFilters ? () => clearFilters() : undefined} />
      {error ? (
        <Table
          columns={headers}
          rows={[]}
          emptyComponent={
            <EmptyState
              title={t('components.molecules.table.noRecord')}
              icon="search_v1"
              size="m"
              className="p-6"
              action={t('components.molecules.table.tryClearFilters')}
              onClick={() => clearFilters()}
              buttonIcon={null}
            />
          }
        />
      ) : (
        <Table
          className="[&_th:nth-child(10)]:p-0 bg-primary h-[calc(100vh-310px)] lightScrollBar"
          onSort={onSort}
          columns={headers}
          rows={rows}
          hasStickyHeader
          emptyComponent={
            <EmptyState
              title={t('components.molecules.table.noRecord')}
              icon="search_v1"
              size="m"
              className="p-6"
              action={t('components.molecules.table.tryClearFilters')}
              onClick={() => clearFilters()}
              buttonIcon={null}
            />
          }
        />
      )}
      <div className={`flex w-full ${onPerPage ? 'justify-between' : 'justify-end'}`}>
        {onPerPage && <ItemsPerPage initialValue={perPage} values={[25, 50, 75, 100]} onChange={onPerPage} />}
        {pagination?.totalPages > 0 && !error && (
          <Pagination
            {...pagination}
            activePage={pagination.currentPage - 1}
            itemCount={pagination.totalPages * perPage}
            itemPerPage={perPage}
            onPageChange={(item) => onPageChange(Number(item.selected) + 1)}
            isFirstButtonVisible
            isLastButtonVisible
            className="flex mt-3"
          />
        )}
      </div>
    </div>
  );
}
